import { render } from "./TicketPacks.vue?vue&type=template&id=2f3190a1&scoped=true&ts=true"
import script from "./TicketPacks.vue?vue&type=script&lang=ts"
export * from "./TicketPacks.vue?vue&type=script&lang=ts"

import "./TicketPacks.vue?vue&type=style&index=0&id=2f3190a1&lang=css"
import "./TicketPacks.vue?vue&type=style&index=1&id=2f3190a1&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f3190a1"]])

export default __exports__